export const contactsFullSelector = (state) => state.userContacts;

export const selectFavoritePhoneNumb = (state) => {
  const favorite = state.userContacts.phoneNumbs.find(
    (phoneNumb) => phoneNumb.mainContact === 'S',
  );
  return favorite;
};

export const selectFavoriteEmail = (state) => {
  const favorite = state.userContacts.emails.find(
    (email) => email.mainContact === 'S',
  );
  return favorite;
};
